export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-10.a5f6ca51.png";